/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SettingsCustomFields_viewer = {
    readonly actualPersonId: string | null;
    readonly id: string;
    readonly company: {
        readonly " $fragmentRefs": FragmentRefs<"CustomFieldTable_company">;
    } | null;
    readonly " $refType": "SettingsCustomFields_viewer";
};
export type SettingsCustomFields_viewer$data = SettingsCustomFields_viewer;
export type SettingsCustomFields_viewer$key = {
    readonly " $data"?: SettingsCustomFields_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SettingsCustomFields_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsCustomFields_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CustomFieldTable_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'c736e7c80c524ca02ee699ac0a546d30';
export default node;
